import { get } from "../methods";
function getDashboardCompanyPerformance(market = "us", headers = {}) {
  return get({
    url: `dashboard/market-performance/${market}`,
    headers
  });
}
export {
  getDashboardCompanyPerformance as default
};
